import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, DATE_TIME_FORMAT, DATA_IS_NULL, TRANSPORTATIN_OBJECT_TYPE, TRANSPORT_TYPE } from "../../../../../../../constants/Define";
import * as HMS from "../../../../../common/component/Index";
import * as Func from '../../../../../../../helpers/functions';
import { isEqual, cloneDeep } from 'lodash';
import Wrapper from './../../../../../common/component/Wrapper';
import Input from "../../../../../common/component/Input";
import { message, Modal, Radio, Alert, Switch, Icon, Collapse, Checkbox, Descriptions, Badge } from 'antd';
import { RedeemTourOrder } from '../../../../../../../models/Order';
import './RedeemTour.less'
import moment from 'moment';
import { getMomentDate } from '../../../../../../../utils/commonUtils';
import Select, { Option } from '../../../../../common/component/Select';
import { getAirline, getAirport, getRoutes, getTransportations, getVehicle, getVehicleTypes } from '../../../../../../../services/orderService';
import AntSelect, { AntOption } from '../../../../../common/component/AntSelect';
import { faThList } from '@fortawesome/free-solid-svg-icons';
import Transportation from './Transportation/Transportation';
import SwitchType from './SwitchType/SwitchType';
import NoticeModal from './NoticeModal';
import * as OrderService from '../../../../../../../services/orderService';
import SurchargeTable from './SurchargeTable';

const { TextArea } = Input;
const { Panel } = Collapse

const initInfo = {
    id: null,
    name: '',
    dateTimeValue: '',
    transportDate: '',
    transportTime: '',
    object: '',
    numOfAdult: 0,
    numOfChild: 0,
    transportType: '',
    routeId: null,
    vehicleTypeId: null,
    vehicleId: null,
    departureLocation: '',
    arrivalLocation: '',
    flightNumber: '',
    note: '',
    confirmationNumbers: []
}

const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    validationProfile: [],
    validationTransportation: [],
    isGetItem: false,
    isChecked: false,
    indexConf: 0,
    typeFormTransportation: 'create',
    dataCreateTransportation: [],
    dataUpdateTransportation: [],
    airlines: [],
    airports: [],
    routes: [],
    vehicleTypes: [],
    vehicles: [],
    indexSelectedTransportation: [],
    propertyId: undefined,
    openModalNotice: false,
    isListProvisions: true
};

class RedeemTour extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            dataRedeem: new RedeemTourOrder(this.props.item),
            indexShow: 0
        }
    }

    componentDidMount() {
        this.props.dataPropertyLoadAllAction({types: 2});
    }
    
    initDataFlight = async () => {
        // const airlines = await getAirline();
        const airports = await getAirport();
        this.setState({
            // airlines: airlines.data.data, 
            airports: airports.data.data
        })
    }

    initRoutes = async (propertyID) => {
        const routes = await getRoutes(propertyID)
        this.setState({
            routes: routes.data
        })
    }

    initTransportation = async (propertyID, confirmationNumber) => {
        const transportations = await getTransportations(propertyID, confirmationNumber)
        this.setState({ dataUpdateTransportation: transportations.data })
    }

    componentWillUnmount() {
        
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.redeemData && !isEqual(nextProps.redeemData, this.props.redeemData)) {
            this.setState({ isChecked: nextProps.redeemData.itineraryNumber && nextProps.redeemData.voucherCode, dataRedeem: cloneDeep(nextProps.redeemData) });
            if(nextProps.redeemData.itineraryNumber && nextProps.redeemData.voucherCode) {
                this.setState({
                    dataCreateTransportation: [{...initInfo}]
                })
                this.initDataFlight()
                if(nextProps.redeemData.dataConfirm && nextProps.redeemData.dataConfirm.reservationInfos){
                    this.initRoutes(nextProps.redeemData.dataConfirm.reservationInfos[0].property.id)
                    this.initTransportation(nextProps.redeemData.dataConfirm.reservationInfos[0].property.id, nextProps.redeemData.dataConfirm.reservationInfos[0].confirmationNumber)
                }
            }
        }
        if (nextProps.orderReducer.recommitErr && !isEqual(nextProps.orderReducer.recommitErr, this.props.orderReducer.recommitErr)) {
            if(nextProps.orderReducer.recommitErr === 'REDEEM_COMMIT_FIXEDCHARGE_ERROR'){
                const { confirm } = Modal;
                confirm({
                    title: 'Thông báo',
                    content: 'Commit fixcharge lỗi. Bạn có muốn redeem mà không commit fixcharge không?',
                    okText: this.props.t(`action.save`),
                    cancelText: this.props.t(`action.cancel`),
                    onOk: ()=> this.onFuncRedeemTour(true),
                });
            }
        }
    }

    render() {
        const { title = '', visible = false, item = {}, onSave , onClose, t } =  this.props;
        const { 
            dataRedeem, isChecked, indexConf, 
            validation,  validationProfile, validationTransportation, 
            typeFormTransportation, dataCreateTransportation, 
            airlines, airports, indexSelectedTransportation ,
            dataUpdateTransportation, routes, vehicleTypes, vehicles,
            indexShow, propertyId, openModalNotice, isListProvisions
        } = this.state;
        const effectiveStartDate = moment(item.effectiveStartDate).format()
        const effectiveEndDate = moment(item.effectiveEndDate).format()

        const buttonDisabled = isChecked && (item.isLocked || !(moment().isAfter(effectiveStartDate) && moment().isBefore(effectiveEndDate)))
               
        return (
                 <Modal
                    width={800}
                    title={title}
                    visible={visible}
                    onOk={() => this.onSubmit()}
                    onCancel={() => this.onCancel()}
                    okText={isChecked ? t('action.save') : t('action.check')}
                    cancelText={isChecked ? t('action.back') : t('action.cancel')}
                    destroyOnClose={true}
                    className="modal-redeem-tour"
                    okButtonProps={{ disabled:  buttonDisabled  }}
                >
                    <HMS.FormWrapperItem>
                        {
                            item.isLocked && 
                            <Wrapper className="col-md-12 m-b">
                                <Alert message={t('item.infoRedeem.NOTIFY_WARNING_LOCK')} type="warning" showIcon />
                            </Wrapper>
                        }
                        {/* <Wrapper className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                labelTitle={t(`item.infoRedeem.ticketName`)}
                            >   
                                <h3>{item.ticketName}</h3>
                            </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                labelTitle={t(`item.infoRedeem.status`)}
                            >   
                                <Wrapper>
                                    <HMS.StatusComponent
                                        color={t(`item.order.orderItemStatusColor.${item.status}`)}
                                        label={t(`item.order.orderItemStatus.${item.status}`)} />
                                </Wrapper>
                            </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                labelTitle={t(`item.tour.effectiveDate`)}
                            >   
                                <Wrapper>
                                    {
                                        item.effectiveStartDate && item.effectiveEndDate && 
                                        <span>
                                            {`${getMomentDate(item.effectiveStartDate).format(DATE_TIME_FORMAT.SHORT_DATE)} - ${getMomentDate(item.effectiveEndDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                                        </span>
                                    }
                                </Wrapper>
                            </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                labelTitle={t(`item.order.serialNumber`)}
                            >   
                                <Wrapper>{item.serialNumber}</Wrapper>
                            </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        {
                            isChecked && dataRedeem.dataConfirm?.reservationInfos.length > 0 && 
                            <Wrapper className="col-md-6">
                                <HMS.FormWrapperInputComponent
                                    labelTitle={t(`item.infoRedeem.hotelName`)}
                                >   
                                    <h3>{dataRedeem.dataConfirm?.reservationInfos[0].property.name}</h3>
                                </HMS.FormWrapperInputComponent>
                            </Wrapper>  
                        }
                        {
                            isChecked && dataRedeem.dataConfirm?.voucherProperties.length > 0 && 
                            <Wrapper className="col-md-6 m-b">
                                <HMS.FormWrapperInputComponent
                                    isRequired={true}
                                    isValidation={true}
                                    dataValidation={dataRedeem.propertyId}
                                    validation={validation.propertyId}
                                    labelTitle={t(`item.tourTicket.propertyToUse`)}
                                >   
                                    <AntSelect className="select-destination"
                                        showArrow showSearch
                                        placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tourTicket.propertyToUse")).toLowerCase()) }
                                        value={ propertyId }
                                        onChange={id => this.setState({ propertyId: id })}
                                        style={ { width: '100%' } }
                                        filterOption={ this.selectFilterSearch }
                                    >
                                        { dataRedeem.dataConfirm?.voucherProperties.map(d => (
                                            <AntOption key={ d.id } value={ d.id }>{ d.name }</AntOption>
                                        )) }
                                    </AntSelect>
                                </HMS.FormWrapperInputComponent>
                            </Wrapper>
                        }
                        <Wrapper className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                // isRequired={true}
                                // isValidation={true}
                                // dataValidation={dataRedeem.itineraryNumber}
                                // validation={validation.itineraryNumber}
                                labelTitle={t(`item.infoRedeem.itineraryNumber`)}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={'itineraryNumber'} 
                                    onChange={(e) => this.onChange('itineraryNumber', e.target.value.trim())}
                                    value={Func.checkUndefine(dataRedeem.itineraryNumber)} 
                                    disabled={!!isChecked}
                                />
                            </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={dataRedeem.voucherCode}
                                validation={validation.voucherCode}
                                labelTitle={t(`item.infoRedeem.voucherCode`)}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={'voucherCode'} 
                                    onChange={(e) => this.onChange('voucherCode', e.target.value.trim())}
                                    value={Func.checkUndefine(dataRedeem.voucherCode)} 
                                    disabled={!!isChecked}
                                />
                            </HMS.FormWrapperInputComponent>
                        </Wrapper> */}

                        <Descriptions bordered column={2} className="w-100 m-b">
                            <Descriptions.Item label={t('item.infoRedeem.ticketName')}>
                                {item.ticketName}
                            </Descriptions.Item>
                            <Descriptions.Item label={t('item.infoRedeem.status')}>
                                <HMS.StatusComponent
                                    color={t(`item.order.orderItemStatusColor.${item.status}`)}
                                    label={t(`item.order.orderItemStatus.${item.status}`)} />
                            </Descriptions.Item>
                            <Descriptions.Item label={t('item.tour.effectiveDate')}>
                                {
                                    item.effectiveStartDate && item.effectiveEndDate && 
                                    <span>
                                        {`${getMomentDate(item.effectiveStartDate).format(DATE_TIME_FORMAT.SHORT_DATE)} - ${getMomentDate(item.effectiveEndDate).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                                    </span>
                                }
                            </Descriptions.Item>
                            <Descriptions.Item label={t('item.ticketSold.serialNumber')}>
                                {item.serialNumber}
                            </Descriptions.Item>
                            { isChecked && dataRedeem.dataConfirm?.reservationInfos && dataRedeem.dataConfirm.reservationInfos.length > 0 && 
                                <Descriptions.Item label={t('item.infoRedeem.hotelName')}>
                                    <h3>{dataRedeem.dataConfirm?.reservationInfos[0].property.name}</h3>
                                </Descriptions.Item>
                            }
                        </Descriptions>

                        {
                            isChecked && 
                            <Fragment>
                                <Wrapper className="col-md-6 m-b">
                                    { dataRedeem.dataConfirm?.voucherProperties.length > 0 && <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={dataRedeem.propertyId}
                                        validation={validation.propertyId}
                                        labelTitle={t(`item.tourTicket.propertyToUse`)}
                                    >   
                                        <AntSelect className="select-destination"
                                            showArrow showSearch
                                            placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.tourTicket.propertyToUse")).toLowerCase()) }
                                            value={ propertyId }
                                            onChange={id => this.setState({ propertyId: id })}
                                            style={ { width: '100%' } }
                                            filterOption={ this.selectFilterSearch }
                                        >
                                            { dataRedeem.dataConfirm?.voucherProperties.map(d => (
                                                <AntOption key={ d.id } value={ d.id }>{ d.name }</AntOption>
                                            )) }
                                        </AntSelect>
                                    </HMS.FormWrapperInputComponent>
                                    }
                                </Wrapper>
                                <Wrapper className="col-md-6 m-b displayAlignCenter">
                                    <Switch 
                                        defaultChecked={isListProvisions} 
                                        onChange={(value) => this.onChangeListProvision(value)} 
                                        name={`usageStatus`} 
                                    />
                                    &nbsp;<span>{t('item.tourTicket.listProvisions')}</span>
                                </Wrapper>
                            </Fragment>
                        }
                        <Wrapper className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                // isRequired={true}
                                // isValidation={true}
                                // dataValidation={dataRedeem.itineraryNumber}
                                // validation={validation.itineraryNumber}
                                labelTitle={t(`item.infoRedeem.itineraryNumber`)}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={'itineraryNumber'} 
                                    onChange={(e) => this.onChange('itineraryNumber', e.target.value.trim())}
                                    value={Func.checkUndefine(dataRedeem.itineraryNumber)} 
                                    disabled={!!isChecked}
                                />
                            </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={dataRedeem.voucherCode}
                                validation={validation.voucherCode}
                                labelTitle={t(`item.infoRedeem.voucherCode`)}
                            >
                                <Input placeholder="" type={`text`}
                                    className={`form-control`}
                                    name={'voucherCode'} 
                                    onChange={(e) => this.onChange('voucherCode', e.target.value.trim())}
                                    value={Func.checkUndefine(dataRedeem.voucherCode)} 
                                    disabled={!!isChecked}
                                />
                            </HMS.FormWrapperInputComponent>
                        </Wrapper> 

                        {
                            isChecked && dataRedeem.dataConfirm?.reservationInfos && 
                            <Wrapper className="col-md-12">
                                <Wrapper className="row">
                                    <Wrapper className="col-md-12">
                                        <fieldset>
                                            <legend>{t(`item.infoRedeem.listConfirm`)}</legend>
                                            <div>
                                                <Radio.Group onChange={this.onChangeConfirmNumber} value={indexConf}>
                                                {
                                                    dataRedeem.dataConfirm.reservationInfos.map((item, index) => (
                                                        <div key={item.reservationID}>
                                                            <Radio value={index}>{item.confirmationNumber}</Radio>
                                                        </div>
                                                    ))
                                                }
                                                </Radio.Group>
                                            </div>
                                        </fieldset>
                                    </Wrapper>
                                        <Wrapper className="col-md-12">
                                            <fieldset>
                                                <legend>{t(`item.infoRedeem.surchargeInfo`)}</legend>
                                                <div>
                                                    <SurchargeTable 
                                                        listType='tours'
                                                        removeSurcharge={this.props.removeSurcharge}
                                                        surcharges={dataRedeem.dataConfirm.surchargeItems || []}
                                                        loading={false}
                                                        openModalDetail={this.openDetailSurcharge}
                                                    />
                                                </div>
                                            </fieldset>
                                    </Wrapper>
                                    {/* Start profile */}
                                    <div className="col-md-12 m-t">
                                        <fieldset>
                                            <legend>{t(`item.infoRedeem.titleProfile`)}</legend>
                                            <div className="row section-profile">
                                            {
                                                dataRedeem.dataConfirm.reservationInfos[indexConf].profiles.map((profile, index) => (
                                                    <Fragment key={index}>
                                                        <Wrapper className="col-md-12">
                                                            <h4>Khách {index + 1}</h4>
                                                        </Wrapper>
                                                        <Wrapper className="col-md-3">
                                                            <HMS.FormWrapperInputComponent
                                                                labelTitle={t(`item.infoRedeem.lastName`)}
                                                            >   
                                                                <Input placeholder="" type={`text`}
                                                                    disabled
                                                                    className={`form-control`}
                                                                    name={'lastName'} 
                                                                    onChange={(e) => this.onChangeProfile('lastName', e.target.value, index)}
                                                                    value={Func.checkUndefine(profile.lastName)} 
                                                                />
                                                            </HMS.FormWrapperInputComponent>
                                                        </Wrapper>
                                                        <Wrapper className="col-md-3">
                                                            <HMS.FormWrapperInputComponent
                                                                labelTitle={t(`item.infoRedeem.firstName`)}
                                                            >   
                                                                <Input placeholder="" type={`text`}
                                                                    disabled
                                                                    className={`form-control`}
                                                                    name={'lastName'} 
                                                                    onChange={(e) => this.onChangeProfile('firstName', e.target.value, index)}
                                                                    value={Func.checkUndefine(profile.firstName)} 
                                                                />
                                                            </HMS.FormWrapperInputComponent>
                                                        </Wrapper>
                                                        <Wrapper className="col-md-6">
                                                            <HMS.FormWrapperInputComponent
                                                                isValidation={true}
                                                                dataValidation={profile.email}
                                                                validation={!!validationProfile[index] && validationProfile[index].email}
                                                                labelTitle={t(`item.infoRedeem.email`)}
                                                            >   
                                                                <Input placeholder="" type={`text`}
                                                                    disabled
                                                                    className={`form-control`}
                                                                    name={'email'} 
                                                                    onChange={(e) => this.onChangeProfile('email', e.target.value, index)}
                                                                    value={Func.checkUndefine(profile.email)} 
                                                                />
                                                            </HMS.FormWrapperInputComponent>
                                                        </Wrapper>
                                                        <Wrapper className="col-md-6">
                                                            <HMS.FormWrapperInputComponent
                                                                isValidation={true}
                                                                dataValidation={profile.phoneNumber}
                                                                validation={!!validationProfile[index] && validationProfile[index].phoneNumber}
                                                                labelTitle={t(`item.infoRedeem.phoneNumber`)}
                                                            >   
                                                                <Input placeholder="" type={`text`}
                                                                    disabled
                                                                    className={`form-control`}
                                                                    name={'phoneNumber'} 
                                                                    onChange={(e) => this.onChangeProfile('phoneNumber', e.target.value, index)}
                                                                    value={Func.checkUndefine(profile.phoneNumber)} 
                                                                />
                                                            </HMS.FormWrapperInputComponent>
                                                        </Wrapper>
                                                        <Wrapper className="col-md-6">
                                                            <HMS.FormWrapperInputComponent
                                                                labelTitle={t(`item.infoRedeem.dateOfBirth`)}
                                                            >   
                                                                <HMS.DatePickerComponent className={`form-control`}
                                                                    disabled
                                                                    allowClear={false}
                                                                    format={DATE_TIME_FORMAT.SHORT_DATE}
                                                                    disabledDate={(current) => current && current < moment().add(-1, 'day')}
                                                                    style={{ padding: 0, border: 0 }}
                                                                    onChange={data => this.onChangeProfile('dateOfBirth', (data.fullValue).toISOString(), index )}
                                                                    name={`applyDates`}
                                                                    placeholder={t('item.infoRedeem.dateOfBirth')}
                                                                    value={( profile.dateOfBirth !== DATA_IS_NULL ? moment(profile.dateOfBirth) : null) || null }
                                                                />
                                                            </HMS.FormWrapperInputComponent>
                                                        </Wrapper>
                                                    </Fragment>
                                                ))
                                            }
                                            </div>
                                        </fieldset>
                                    </div>
                                    {/* End profile */}

                                    {/* Start transportation */}
                                    <Wrapper className="col-md-12 m-t">
                                        <fieldset>
                                            <legend>{t(`item.infoRedeem.titleTransportation`)}</legend>
                                            <div className="section-transportation">
                                                <div className="section-transportation-update">
                                                    <div className="select-type-transportation">
                                                        <Radio 
                                                            checked={typeFormTransportation === 'update'}
                                                            onChange={() => this.setState({ typeFormTransportation: 'update', validationTransportation: [] })}
                                                        >
                                                            {t('item.infoRedeem.transportation.update')}
                                                        </Radio>
                                                    </div>
                                                    {
                                                        typeFormTransportation === 'update' && 
                                                        <div className="list-transportation m-l">
                                                            <Collapse 
                                                                accordion
                                                                onChange={this.showTransportation}
                                                                expandIconPosition='right'
                                                            >
                                                            {
                                                                dataUpdateTransportation.map((data, index) => (
                                                                        <Panel header={(
                                                                            <div className="section-update" onClick={e => e.stopPropagation()} key={data.id}>
                                                                                <Checkbox 
                                                                                    checked={indexSelectedTransportation.includes(index)}
                                                                                    onChange={() => this.onChangeCheckbox(index)}
                                                                                >
                                                                                    {data.name}
                                                                                </Checkbox>
                                                                                {
                                                                                    indexSelectedTransportation.includes(index) && 
                                                                                    <Fragment>
                                                                                        <SwitchType 
                                                                                            t={t}
                                                                                            data={data}
                                                                                            index={index}
                                                                                            switchTypeUpdate={this.switchTypeUpdate}
                                                                                        />
                                                                                        <Input placeholder="" type={`text`}
                                                                                            className='input-update'
                                                                                            placeholder="Seri vé máy bay"
                                                                                            name={'newNote'} 
                                                                                            onChange={(e) => this.onChangeUpdateTransportation('newNote', e.target.value, index)}
                                                                                            value={Func.checkUndefine(data.newNote)} 
                                                                                        />
                                                                                    </Fragment>
                                                                                }
                                                                            </div>
                                                                        )} key={index}>
                                                                            { indexShow === index && 
                                                                                <Transportation
                                                                                    item={data}
                                                                                    validationTransportation={validationTransportation}
                                                                                    t={t}
                                                                                    airports={airports}
                                                                                    routes={routes}
                                                                                    vehicleTypesUpdated={[data.vehicleType]}
                                                                                    vehiclesUpdated={[data.vehicle]}
                                                                                    index={index}
                                                                                    isUpdated={true}
                                                                                />
                                                                            }
                                                                        </Panel>
                                                                ))
                                                            }
                                                            </Collapse>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="section-transportation-create">
                                                    <div className="select-type-transportation">
                                                        <Radio 
                                                            checked={typeFormTransportation === 'create'}
                                                            onChange={() => this.setState({ typeFormTransportation: 'create', validationTransportation: [] })}
                                                        >
                                                            {t('item.infoRedeem.transportation.create')}
                                                        </Radio>
                                                    </div>
                                                    {
                                                        typeFormTransportation === 'create' && 
                                                        <div className="form-transportation">
                                                            {
                                                                dataCreateTransportation.map((item, index) => (
                                                                    <Fragment key={index}>
                                                                        <div className="section-transportation m-b">
                                                                            {
                                                                                dataCreateTransportation.length > 1 && <Icon type="minus-circle" className="icon-change-form minus" onClick={() => this.removeTransportation(index)}/>
                                                                            }
                                                                            {
                                                                                index === (dataCreateTransportation.length - 1) && <Icon type="plus-circle" className="icon-change-form plus" onClick={this.addNewTransportation}/>
                                                                            }
                                                                            <Transportation
                                                                                item={item}
                                                                                validationTransportation={validationTransportation}
                                                                                t={t}
                                                                                onChangeTransportation={this.onChangeTransportation}
                                                                                onSelectObjectType={this.onSelectObjectType} 
                                                                                onChangeDateTransportation={this.onChangeDateTransportation}
                                                                                airports={airports}
                                                                                routes={routes}
                                                                                index={index}
                                                                                propertyId={dataRedeem.dataConfirm.reservationInfos[indexConf].property.id}
                                                                            />
                                                                        </div>
                                                                    </Fragment>
                                                                ))
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                                <div className="section-transportation-create">
                                                    <div className="select-type-transportation">
                                                        <Radio 
                                                            checked={typeFormTransportation === 'ignore'}
                                                            onChange={() => this.setState({ typeFormTransportation: 'ignore', validationTransportation: [] })}
                                                        >
                                                            {t('item.infoRedeem.transportation.ignore')}
                                                        </Radio>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                    </Wrapper>
                                    {/* End transportation */}

                                    <Wrapper className="col-md-12 m-t">
                                        <HMS.FormWrapperInputComponent
                                            labelTitle={t(`item.infoRedeem.note`)}
                                        >
                                            <TextArea 
                                                className={`form-control`}
                                                rows={4} 
                                                name={'note'} 
                                                onChange={(e) => this.onChange('note', e.target.value)}
                                                value={Func.checkUndefine(dataRedeem.note)} 
                                            />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    {
                                        !(moment().isAfter(effectiveStartDate) && moment().isBefore(effectiveEndDate)) && 
                                        <Wrapper className="col-md-12 m-t">
                                            <Alert 
                                                message={
                                                    moment().isBefore(effectiveStartDate) ? t('validation.statusCode.code.VOUCHER_NOT_STARTED_YET') :
                                                    (moment().isAfter(effectiveEndDate) ? t('validation.statusCode.code.VOUCHER_WAS_EXPIRED') : '')
                                                } 
                                                type="error" 
                                                showIcon 
                                            />
                                        </Wrapper>
                                    }
                                </Wrapper>
                            </Wrapper>
                        }
                    </HMS.FormWrapperItem>
                    <NoticeModal
                        openModalNotice={openModalNotice}
                        handleSubmitRedeem={this.submitRedeemTour}
                        handleCancelRedeem={this.toggleNoticeModal}
                    />
                </Modal>
        )
    }

    onChangeCheckbox = (indexSelected) => {
        const { indexSelectedTransportation } = this.state;
        let indexArr = [...indexSelectedTransportation]
        if(indexSelectedTransportation.includes(indexSelected)) {
            indexArr = indexSelectedTransportation.filter(index => index !== indexSelected)
        } else {
            indexArr.push(indexSelected)
        }

        this.setState({ indexSelectedTransportation: indexArr })
    }

    onChangeListProvision = (checked)=> {
        this.setState({ isListProvisions: checked })
        if(!checked){
            const { dataRedeem } = this.state;
            const { tourPropertyReducer } = this.props;
            const properties = tourPropertyReducer.data.result;
            const { voucherProperties } = dataRedeem.dataConfirm;
            const arrNoInclude = properties.filter(item => {
                return !(voucherProperties || []).filter(it => it.id === item.id).length > 0
            });
            dataRedeem.dataConfirm.voucherProperties = arrNoInclude;
            this.setState({ dataRedeem })
        }else{
            this.setState({ dataRedeem: cloneDeep(this.props.redeemData)})
        }
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props.children.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };

    showTransportation = (key) => {
        this.setState({ indexShow: parseInt(key) })
    }

    removeTransportation = (index) => {
        const transportations = [...this.state.dataCreateTransportation]
        transportations.splice(index, 1)
        this.setState({ dataCreateTransportation: transportations });
    }

    addNewTransportation = () => {
        this.setState({
            dataCreateTransportation: [...this.state.dataCreateTransportation, {...initInfo}]
        })
    }

    onChangeUpdateTransportation = (field, value, index) => {
        const { dataUpdateTransportation } = this.state;
        dataUpdateTransportation[index].newNote = value;
        this.setState({ dataUpdateTransportation });
    }

    switchTypeUpdate = (value, index) => {
        const { dataUpdateTransportation } = this.state;
        dataUpdateTransportation[index].isAdult = value
        this.setState({ dataUpdateTransportation })
    }

    onChangeDateTransportation = (field, value, index) => {
        const { dataCreateTransportation } = this.state;

        const dataDate = moment(value).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT)
        const dataTime = moment(value).format(DATE_TIME_FORMAT.SHORT_TIME)

        dataCreateTransportation[index][field] = value;
        dataCreateTransportation[index].transportDate = dataDate;
        dataCreateTransportation[index].transportTime = dataTime;
        this.setState({ dataCreateTransportation });
    }

    onSelectObjectType = (field, value, index) => {
        const { dataCreateTransportation } = this.state;
        dataCreateTransportation[index][field] = value
        this.setState({ dataCreateTransportation })
    }

    onChangeTransportation = (field, value, index) => {
        const { dataCreateTransportation } = this.state;
        dataCreateTransportation[index][field] = value;
        this.setState({ dataCreateTransportation });
    }

    onChangeProfile = (field, value, indexProfile) => {
        const { dataRedeem, indexConf } = this.state;
        dataRedeem.dataConfirm.reservationInfos[indexConf].profiles[indexProfile][field] = value;
        this.setState({ dataRedeem });
    }

    onChangeConfirmNumber = (e) => {
        const { dataRedeem } = this.state;
        this.initTransportation(dataRedeem.dataConfirm.reservationInfos[0].propertyID, dataRedeem.dataConfirm.reservationInfos[e.target.value].confirmationNumber)
        this.setState({ indexConf: e.target.value })
    }

    onChange = (fieldName, value) => {
        const dataRedeem = this.state.dataRedeem;
        dataRedeem[fieldName] = value;
        this.setState({ dataRedeem });
    };

    onCancel = () => {
        const { isChecked } = this.state;
        if(!isChecked) {
            return this.props.onClose()
        }
        this.setState({ 
            ...defaultState
        })
        this.props.setInfoRedeem((new RedeemTourOrder(this.props.item)))
    }

    onSubmit = () => {
        const { isChecked, dataRedeem, indexConf, typeFormTransportation, indexSelectedTransportation, dataUpdateTransportation, dataCreateTransportation, propertyId } = this.state;
        if(!isChecked) {
            return this.onCheck();
        }
        // if(!this.validateProfile()) {
        //     return message.error('Vui lòng kiểm tra lại dữ liệu thông tin khách hàng!')
        // }

        if(this.validateProperty()) {
            
            this.onFuncRedeemTour();
            // this.props.onClose()
        }
        
    }

    onFuncRedeemTour = (isIgnoreFixcharge = undefined)=>{
        const { isChecked, dataRedeem, indexConf, typeFormTransportation, indexSelectedTransportation, dataUpdateTransportation, dataCreateTransportation, propertyId } = this.state;
        let newDataRedeem = {};
        let transportationData = []
        if(typeFormTransportation === 'ignore') {
            transportationData = []
        } else if (typeFormTransportation === 'update') {
            const mappingDataUpdate = this.mappingTransportation();
            transportationData = mappingDataUpdate
        } else {
            if(!this.validateTranportation()) {
                return message.error('Vui lòng kiểm tra lại dữ liệu thông tin vận chuyển!')
            }
            const mapTransportations = dataCreateTransportation.map(transportation => ({
                ...transportation,
                numOfAdult: transportation.object === "numOfAdult" ? 1 : 0,
                numOfChild: transportation.object === "numOfChild" ? 1 : 0,
                confirmationNumbers: this.parseConfirmationNumbers(dataRedeem, indexConf)
            }))
            transportationData = mapTransportations
        }
        
        newDataRedeem = Object.assign(dataRedeem, {transportations: transportationData, redeemPropertyId: propertyId, isIgnoreFixcharge: isIgnoreFixcharge})
        this.props.redeemTour(newDataRedeem, indexConf, {
            onSuccess: this.props.onClose
        })
    }

    mappingTransportation = () => {
        const { indexSelectedTransportation, dataUpdateTransportation, dataRedeem, indexConf } = this.state
        return indexSelectedTransportation.map(index => {
            let dataUpdate = dataUpdateTransportation[index]
            const mappingDataUpdate = {
                ...dataUpdate,
                note: dataUpdate.note + (dataUpdate.newNote ? `,${dataUpdate.newNote}` : ''),
                routeId: dataUpdate.route?.id,
                vehicleTypeId: dataUpdate.vehicleType?.id,
                vehicleId: dataUpdate.vehicle?.id,
                confirmationNumbers: this.parseConfirmationNumbers(dataRedeem, indexConf)
            }
            const typeCustomer = dataUpdate.isAdult ? 'numOfAdult' : 'numOfChild'
            mappingDataUpdate[typeCustomer] = mappingDataUpdate[typeCustomer] + 1

            return mappingDataUpdate
        })
    }

    parseConfirmationNumbers = (dataRedeem, indexConf) => {
        return [
            {
                confirmationNumber: dataRedeem.dataConfirm.reservationInfos[indexConf].confirmationNumber,
                propertyId: dataRedeem.dataConfirm.reservationInfos[indexConf].property.id,
                reservationId: dataRedeem.dataConfirm.reservationInfos[indexConf].reservationID,
                itineraryNumber: dataRedeem.itineraryNumber,
            }
        ]
    }

    toggleNoticeModal = () => {
        this.setState({ openModalNotice: !this.state.openModalNotice })
    }

    submitRedeemTour = () => {
        this.props.redeemTour(this.state.dataRedeem)
        this.toggleNoticeModal()
        this.props.onClose()
    }


    onCheck = async () => {
        if(!this.state.dataRedeem.itineraryNumber && this.validate()) {
            try {
                const res = await OrderService.checkDataRedeem(this.state.dataRedeem)
                if(!!res) {
                    return this.toggleNoticeModal()
                }
            } catch (e) {
                
            }
            // return this.toggleNoticeModal()
        }
        if(this.validate()) {
            this.props.checkRedeem(this.state.dataRedeem)
        }
    }

    validate() {
        const { t } = this.props;
        const { isChecked } = this.state; 
        let validate = {
            required: {
                // itineraryNumber: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.itineraryNumber`)),
                voucherCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.voucherCode`))
            }
        };
        if(isChecked) {
            validate.required.propertyId = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tourTicket.propertyToUse`))
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.dataRedeem, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    validateProperty() {
        const { t } = this.props;
        const { isChecked } = this.state; 
        let validate = {
            required: {}
        }
        if(isChecked) {
            validate.required.propertyId = Func.formatValidation(t('validation.statusCode.code.1'), t(`item.tourTicket.propertyToUse`))
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    validateProfile() {
        let result = []
        let isErrors = 0
        const { t } = this.props;
        const { dataRedeem, indexConf } = this.state
        let validate = {
            required: {
                email: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.email`)),
                phoneNumber: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.phoneNumber`))
            },
            isEmail: { email: t('validation.email') },
            isPhone: { phoneNumber: t('validation.isPhone') }
        };
        let valueValidate = {};
        dataRedeem.dataConfirm.reservationInfos[indexConf].profiles.forEach((profile, index) => {
            const resultProfile = Func.multipleValidate(profile, validate, valueValidate, true);
            if(Object.keys(resultProfile).length > 0) {
                isErrors++
            }
            result.push(resultProfile)
        })
        this.setState({ validationProfile: result });
        return isErrors === 0
    }

    validateTranportation() {
        let result = []
        let isErrors = 0
        const { t } = this.props;
        const { dataCreateTransportation } = this.state
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.transportation.name`)),
                dateTimeValue: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.transportation.transportDateTime`)),
                object: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.transportation.object`)),
                transportType: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.transportation.transportType`)),
                routeId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.transportation.route`)),
                vehicleTypeId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.transportation.vehicleType`)),
                vehicleId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.infoRedeem.transportation.vehicle`))
            }
        };
        let valueValidate = {};
        dataCreateTransportation.forEach((transportation, index) => {
            const resultValidation = Func.multipleValidate(transportation, validate, valueValidate, true);
            if(Object.keys(resultValidation).length > 0) {
                isErrors++
            }
            result.push(resultValidation)
        })
        this.setState({ validationTransportation: result });
        return isErrors === 0
    }
}

export default RedeemTour;
